var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-polygon-container"},[_c('canvas',{staticStyle:{"background":"antiquewhite"},attrs:{"id":"quad","width":"1500","height":"1000"}}),_c('canvas',{attrs:{"id":"myCanvas","width":"500","height":"500"}})])
}]

export { render, staticRenderFns }